import React from "react";
import { TaglineLines } from "@/components/home/SectionTitle";

export const CAMPUS = "https://images.unsplash.com/photo-1591123120675-6f7f1aae0e5b?w=1600&q=80";

export const AboutHeader = ({ kicker, title }) => (
  <section className="bg-[#0F1B2D] text-white pt-28 sm:pt-36 pb-16 sm:pb-24 relative grain">
    <div
      className="absolute inset-0 opacity-30"
      style={{
        backgroundImage: `linear-gradient(rgba(15,27,45,0.85), rgba(15,27,45,0.95)), url(${CAMPUS})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="overline text-[#C4A46A]">{kicker}</div>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight">{title}</h1>
      <span className="gold-rule mt-8 block" />
    </div>
  </section>
);

export const Heading = ({ kicker, title, dark = false, kickerClass = "" }) => (
  <>
    <div className={`overline ${kickerClass}`}>{kicker}</div>
    <h2 className={`mt-3 font-display text-4xl lg:text-5xl tracking-tight ${dark ? "" : "text-[#0F1B2D]"}`}>{title}</h2>
    <span className="gold-rule mt-6 block" />
  </>
);

export const Prose = ({ paras, className = "mt-6 space-y-5 text-[#5E6470] text-lg leading-relaxed" }) => (
  <div className={className}>
    {paras.map((p) => (
      <p key={p}>{p}</p>
    ))}
  </div>
);

const BrandAside = ({ tagline, taglineSecondary }) => (
  <div className="border-l border-[#C4A46A]/50 pl-8 lg:sticky lg:top-32">
    <img src="/nc-logo.png" alt="Northcrest" width={64} height={64} className="opacity-90" />
    <p className="mt-10 font-display text-[#0F1B2D] text-2xl lg:text-3xl leading-snug tracking-tight"><TaglineLines text={tagline} /></p>
    <span className="gold-rule mt-8 block" />
    <p className="mt-6 font-serif-italic text-[#5E6470] text-lg">{taglineSecondary}</p>
  </div>
);

export const AboutMission = ({ t, a }) => (
  <section className="bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5">
        <BrandAside tagline={t.common.tagline} taglineSecondary={t.common.taglineSecondary} />
      </div>
      <div className="lg:col-span-7" data-testid="about-mission">
        <Heading kicker={a.missionT} title={a.missionT} />
        <Prose paras={a.missionParas} />
      </div>
    </div>
  </section>
);

export const AboutVision = ({ a }) => (
  <section className="bg-[#0F1B2D] text-white">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-16">
      <div className="lg:col-span-5 lg:order-2">
        <div className="border-l border-[#C4A46A]/50 pl-8 lg:sticky lg:top-32">
          <div className="overline text-[#C4A46A]">Europe → United States</div>
          <p className="mt-6 font-display text-3xl lg:text-4xl tracking-tight leading-snug">
            Europe.
            <br />
            <span className="text-[#C4A46A] font-serif-italic">United States.</span>
          </p>
          <span className="gold-rule mt-8 block" />
        </div>
      </div>
      <div className="lg:col-span-7 lg:order-1" data-testid="about-vision">
        <Heading kicker={a.visionT} title={a.visionT} dark kickerClass="text-[#C4A46A]" />
        <Prose paras={a.visionParas} className="mt-6 space-y-5 text-white/80 text-lg leading-relaxed" />
      </div>
    </div>
  </section>
);

export const AboutValues = ({ a }) => (
  <section className="bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24">
      <div className="mb-14 max-w-3xl">
        <Heading kicker={a.valuesT} title={a.valuesT} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0F1B2D]/10">
        {a.valuesItems.map((v, i) => (
          <div key={v.t} data-testid={`value-${i}`} className="bg-[#F4F0E8] p-10 flex flex-col min-h-[320px]">
            <div className="font-display text-[#C4A46A] text-sm">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="mt-4 font-display text-2xl text-[#0F1B2D] tracking-tight">{v.t}</h3>
            <span className="gold-rule mt-4 block" />
            <Prose paras={v.paras} className="mt-5 space-y-3 text-[#5E6470] text-[15px] leading-relaxed" />
          </div>
        ))}
      </div>
    </div>
  </section>
);
